import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import bundleNS from './constants/bundleNS';
import { getUserId } from '../../localStorages';

export default data => {
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataModify = parseToMutationRequest(newData, bundleNS);
  const modifyBundle = `modifyBundle(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyBundle} {
      id
      name
      description
      minimumQuantity
      maximumQuantity
      salesChannel
      marketSegment
      accountType
      accountSubType
      country
      currency
      startDate
      endDate
      status
      components{
        index
        serviceType
        serviceAddOn
        priceOfferId
        discountOfferId
        bundleId
        validityDuration
        validityUnit
      }
    }
  }
`;
};
